import {Image} from 'antd-mobile';
import React, {useMemo} from 'react';
import {vipOptionsV2} from './vip.variable';
import {cn} from '@/utils';
const VipSmall = ({level, className}: {level?: number; className?: string}) => {
  const {small} = useMemo(() => {
    if (!level) {
      return vipOptionsV2[0];
    }
    if (!vipOptionsV2[level]) {
      return vipOptionsV2[0];
    }
    return vipOptionsV2[level];
  }, [level]);
  return (
    <Image
      src={small}
      className={cn('h-9 [&_.adm-image-img]:w-auto', className)}
    />
  );
};

export default VipSmall;
